import React, { useEffect, useState } from "react";
import { Landmark, Trash2 } from "lucide-react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

export const PERM_MSG = "ఇది శాశ్వతంగా తొలగించబడుతుంది, మళ్ళీ తిరిగి రాదు. ఖచ్చితంగా తొలగించాలా?";

export default function MyTemples() {
  const [list, setList] = useState([]);
  const load = () => { api.get("/me/temples").then(({ data }) => setList(data)).catch(() => {}); };
  useEffect(() => { load(); }, []);

  const del = async (tid) => {
    if (!window.confirm(PERM_MSG)) return;
    try { await api.delete(`/me/temples/${tid}`); toast.success("శాశ్వతంగా తొలగించబడింది"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "లోపం"); }
  };

  return (
    <Card className="p-6 bg-surface gold-border temple-shadow" data-testid="my-temples">
      <h3 className="font-serifte font-bold text-maroon text-lg flex items-center gap-2 mb-1"><Landmark className="w-5 h-5 text-saffron" />నా దేవాలయ ప్రకటనలు</h3>
      <p className="text-xs text-muted-foreground font-telugu mb-3">అర్చకులు దొరికిన తర్వాత ప్రకటనను ఇక్కడ నుంచి తొలగించవచ్చు.</p>
      {list.length === 0 ? (
        <div className="text-center py-2"><p className="text-sm text-muted-foreground font-telugu mb-2">మీరు ఇంకా ప్రకటన ఇవ్వలేదు</p>
          <Link to="/post-vacancy" data-testid="my-temples-post" className="text-saffron underline text-sm font-telugu">ప్రకటన ఇవ్వండి</Link></div>
      ) : list.map((tm) => (
        <div key={tm.id} className="flex items-center justify-between gap-2 py-2 border-b border-goldline/20 last:border-0" data-testid={`my-temple-${tm.id}`}>
          <div className="min-w-0">
            <Link to={`/temples/${tm.id}`} className="font-semibold text-maroon font-telugu hover:underline">{tm.name}</Link>
            <div className="text-xs text-muted-foreground font-telugu">{tm.village}, {tm.district} · <Badge variant="outline" className="text-[10px]">{tm.status}</Badge></div>
          </div>
          <Button size="sm" variant="outline" data-testid={`my-temple-delete-${tm.id}`} onClick={() => del(tm.id)} className="text-destructive h-8 font-telugu shrink-0">
            <Trash2 className="w-3.5 h-3.5 mr-1" />తొలగించు
          </Button>
        </div>
      ))}
    </Card>
  );
}
